import customerApi from 'api/customerApi';

const TABS = {
  ACTIVE: 'ACTIVE',
  BLOCKED: 'BLOCKED',
};

const ACCOUNT_TYPES_MAP = {
  MEMBER: 'Thành viên',
  TOURIST: 'Du khách',
  AGENT: 'Đại lý',
  ENTERPRISE: 'Doanh nghiệp',
};

export const normalizeCustomerFromApi = (customer) => {
  const rawType = customer?.accountType || customer?.level || '';
  const normalizedType = ACCOUNT_TYPES_MAP[String(rawType).toUpperCase().trim()] || rawType || 'Du khách';

  return {
    _id: customer?._id || customer?.id || '',
    fullName: customer?.fullName || customer?.name || '',
    accountType: normalizedType,
    email: customer?.email || '',
    phoneNumber: customer?.phoneNumber || customer?.phone || '',
    lastLogin: customer?.lastLogin || '—',
    status: customer?.isBlocked ? TABS.BLOCKED : TABS.ACTIVE,
    avatar: customer?.avatar || customer?.avatarUrl || '',
  };
};

export const getCustomerList = async (payload) => {
  const response = await customerApi.getCustomerList(payload);
  const result = response?.payload ?? response;
  const list = result?.data || result?.items || result || [];
  return Array.isArray(list) ? list : [];
};

export const blockCustomer = async (id) => {
  await customerApi.blockCustomer(id);
};

export const unblockCustomer = async (id) => {
  await customerApi.unblockCustomer(id);
};
